export class MhahLocalConstant {
  Ritu = {
    name: ['ବସନ୍ତ', 'ଗ୍ରୀଷ୍ମ', 'ବର୍ଷା', 'ଶରତ', 'ହେମନ୍ତ', 'ଶୀତ'],
    name_en_UK: [
      'Spring',
      'Summer',
      'Monsoon',
      'Autumn',
      'Pre-Winter',
      'Winter',
    ],
  };
  Masa = {
    name: [
      'ବୈଶାଖ',
      'ଜ୍ୟେଷ୍ଠ',
      'ଆଷାଢ',
      'ଶ୍ରାବଣ',
      'ଭାଦ୍ରବ',
      'ଆଶ୍ଵିନ',
      'କାର୍ତ୍ତିକ',
      'ମାର୍ଗଶିର',
      'ପୌଷ',
      'ମାଘ',
      'ଫାଲ୍ଗୁନ',
      'ଚୈତ୍ର',
    ],
    name_en_IN: [
      'Baisakha',
      'Jyestha',
      'Asadha',
      'Srabana',
      'Bhadraba',
      'Aswina',
      'Karttika',
      'Margasira',
      'Pausa',
      'Magha',
      'Phalguna',
      'Chaitra',
    ],
  };
  Raasi: {
    name: string[];
    name_en_UK: string[];
  } = {
    name: [
      'ମେଷ',
      'ବୃଷ',
      'ମିଥୁନ',
      'କର୍କଟ',
      'ସିଂହ',
      'କନ୍ୟା',
      'ତୁଳା',
      'ବିଛା',
      'ଧନୁ',
      'ମକର',
      'କୁମ୍ଭ',
      'ମୀନ',
    ],
    name_en_UK: [
      'Aries',
      'Taurus',
      'Gemini',
      'Cancer',
      'Leo',
      'Virgo',
      'Libra',
      'Scorpio',
      'Sagittarius',
      'Capricorn',
      'Aquarius',
      'Pisces',
    ],
  };
  Day = {
    name: [
      'ରବିବାର',
      'ସୋମବାର',
      'ମଙ୍ଗଳବାର',
      'ବୁଧୁବାର',
      'ଗୁରୁବାର',
      'ଶୁକ୍ରବାର',
      'ଶନିବାର',
    ],
    name_en_UK: [
      'Sunday',
      'Monday',
      'Tuesday',
      'Wednesday',
      'Thursday',
      'Friday',
      'Saturday',
    ],
  };
  Nakshatra = {
    name: [
      'ଅଶ୍ଵିନୀ',
      'ଦ୍ଵିଜା',
      'କୃତ୍ତିକା',
      'ରୋହିଣୀ',
      'ମୃଗଶିରା',
      'ଆର୍ଦ୍ରା',
      'ପୁନର୍ବସୁ',
      'ପୁଷ୍ୟା',
      'ଆଶ୍ଳେଷା',
      'ମଘା',
      'ପୂର୍ବଫାଲ୍ଗୁନୀ',
      'ଉତ୍ତରାଫାଲ୍ଗୁନୀ',
      'ହସ୍ତା',
      'ଚିତ୍ରା',
      'ସ୍ଵାତୀ',
      'ବିଶାଖା',
      'ଅନୁରାଧା',
      'ଜ୍ୟେଷ୍ଠା',
      'ମୂଳା',
      'ପୂର୍ବଷାଢା',
      'ଉତ୍ତରାଷାଢା',
      'ଶ୍ରବଣା',
      'ଧନିଷ୍ଠା',
      'ସତଭିଷା',
      'ପୂର୍ବଭାଦ୍ର',
      'ଉତ୍ତରାଭାଦ୍ର',
      'ରେବତୀ',
    ],

    name_en_IN: [
      'Ashwini',
      'Dwija',
      'Krittika',
      'Rohini',
      'Mrigashirsha',
      'Ardra',
      'Punarvasu',
      'Pushya',
      'Ashlesha',
      'Magha',
      'Purva Phalguni',
      'Uttara Phalguni',
      'Hasta',
      'Chitra',
      'Swati',
      'Vishakha',
      'Anuradha',
      'Jyeshtha',
      'Mula',
      'Purva Ashadha',
      'Uttara Ashadha',
      'Sravana',
      'Dhanishta',
      'Shatabhisha',
      'Purva Bhadrapada',
      'Uttara Bhadrapada',
      'Rebati',
    ],
  };
  Paksha = {
    name_en_IN: ['Shukla', 'Krishna'],
    name_en_UK: ['Waxing Moon', 'Waning Moon'],
    name: ['ଶୁକ୍ଲ', 'କୃଷ୍ଣ'],
  };

  Tithi = {
    name: [
      'ପ୍ରତିପଦା',
      'ଦ୍ଵିତୀୟା',
      'ତୃତୀୟା',
      'ଚତୁର୍ଥୀ',
      'ପଞ୍ଚମୀ',
      'ଷଷ୍ଠୀ',
      'ସପ୍ତମୀ',
      'ଅଷ୍ଟମୀ',
      'ନବମୀ',
      'ଦଶମୀ',
      'ଏକାଦଶୀ',
      'ଦ୍ଵାଦଶୀ',
      'ତ୍ରୟୋଦଶୀ',
      'ଚତୁର୍ଦ୍ଦଶୀ',
      'ପୁର୍ଣିମା',
      'ପ୍ରତିପଦା',
      'ଦ୍ଵିତୀୟା',
      'ତୃତୀୟା',
      'ଚତୁର୍ଥୀ',
      'ପଞ୍ଚମୀ',
      'ଷଷ୍ଠୀ',
      'ସପ୍ତମୀ',
      'ଅଷ୍ଟମୀ',
      'ନବମୀ',
      'ଦଶମୀ',
      'ଏକାଦଶୀ',
      'ଦ୍ଵାଦଶୀ',
      'ତ୍ରୟୋଦଶୀ',
      'ଚତୁର୍ଦ୍ଦଶୀ',
      'ଅମାବାସ୍ୟା',
    ],
    name_en_IN: [
      'Padyami',
      'Vidhiya',
      'Thadiya',
      'Chavithi',
      'Panchami',
      'Shasti',
      'Sapthami',
      'Ashtami',
      'Navami',
      'Dasami',
      'Ekadasi',
      'Dvadasi',
      'Trayodasi',
      'Chaturdasi',
      'Punnami',
      'Padyami',
      'Vidhiya',
      'Thadiya',
      'Chaviti',
      'Panchami',
      'Shasti',
      'Sapthami',
      'Ashtami',
      'Navami',
      'Dasami',
      'Ekadasi',
      'Dvadasi',
      'Trayodasi',
      'Chaturdasi',
      'Amavasya',
    ],
  };
  Karna = {
    name_en_IN: [
      'Bawa',
      'Balava',
      'Kaulava',
      'Taitula',
      'Garaja',
      'Vanija',
      'Vishti',
      'Sakuna',
      'Chatushpada',
      'Nagava',
      'Kimstughana',
    ],
    name: [
      'ବବ',
      'ବାଳବ',
      'କୌଳବ',
      'ତୈତିଳ',
      'ଗର',
      'ବାଣିଜ୍ୟ',
      'ବିଷ୍ଟି',
      'ଶକୁନି',
      'ଚତୁଷ୍ପଦ',
      'ନାଗ',
      'କିଂସ୍ତୁଘ୍ନ',
    ],
  };
  Yoga = {
    name_en_IN: [
      'Vishkambha',
      'Prithi',
      'Ayushman',
      'Saubhagya',
      'Sobhana',
      'Atiganda',
      'Sukarman',
      'Dhrithi',
      'Soola',
      'Ganda',
      'Vridhi',
      'Dhruva',
      'Vyaghata',
      'Harshana',
      'Vajra',
      'Siddhi',
      'Vyatipata',
      'Variyan',
      'Parigha',
      'Siva',
      'Siddha',
      'Sadhya',
      'Subha',
      'Sukla',
      'Bramha',
      'Indra',
      'Vaidhruthi',
    ],
    name: [
      'ବିଷ୍ କୁମ୍ଭ',
      'ପ୍ରୀତି',
      'ଆୟୁଷ୍ମାନ',
      'ସୌଭାଗ୍ୟ',
      'ଶୋଭନ',
      'ଅତିଗଣ୍ଡ',
      'ସୁକର୍ମା',
      'ଧୃତି',
      'ଶୂଳ',
      'ଗଣ୍ଡ',
      'ବୃଦ୍ଧି',
      'ଧ୍ରୁବ',
      'ବ୍ୟାଘାତ',
      'ହର୍ଷଣ',
      'ବଜ୍ର',
      'ଅସୃକ୍',
      'ବ୍ୟତିପାତ',
      'ବରୀୟାନ',
      'ପରିଘ',
      'ଶିବ',
      'ସିଦ୍ଧ',
      'ସାଧ୍ଧ',
      'ଶୁଭ',
      'ଶୁକ୍ଳ',
      'ବ୍ରହ୍ମ',
      'ଇନ୍ଦ୍ର',
      'ବୈଧୃତି',
    ],
  };
  Trinity = {
    name_en_IN: ['Brahma', 'Vishnu', 'Shiva'],
    name: ['ବ୍ରହ୍ମା', 'ବିଷ୍ଣୁ', 'ଶିବ'],
  };
  Guna = {
    name_en_IN: ['Rajas', 'Tamas', 'Satva'],
    name_en_UK: [
      'passion, activity, movement',
      'ignorance, inertia, laziness',
      'goodness, calmness, harmonious',
    ],
    name: ['ରାଜସ୍', 'ତମାସ୍', 'ସତ୍ୟ'],
  };

  Gana = {
    name_en_IN: ['Devata', 'Manushya', 'Rakshasa'],
    name_en_UK: ['God', 'Human', 'Demon'],
    name: ['ଦେବତା', 'ମନୁଷ୍ୟ', 'ରାକ୍ଷସ'],
  };
}
